import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "../src/index.css";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

import { env } from "../env";

const rootElement = document.getElementById("app")!;

// Update favicon based on environment
document.addEventListener("DOMContentLoaded", () => {
  const prodMode = localStorage.getItem("prodMode") === "true";
  const link = document.querySelector("link[rel='icon']") as HTMLLinkElement;
  if (link && env.VITE_ENVIRONMENT !== "production" && !prodMode) {
    link.href = "/devfavicon.ico";
  }
});

posthog.init(env.VITE_POSTHOG_PUBLIC_KEY, {
  // We are doing this: https://posthog.com/docs/advanced/proxy/cloudflare
  api_host: "https://p.givefront.com",
  ui_host: "us.posthog.com",
});

Sentry.init({
  dsn: "https://0b26c9fd716d1da6b8e1b90025d1e71c@o4510711172038656.ingest.us.sentry.io/4510711179575296",
  environment: env.VITE_ENVIRONMENT,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    // If toasts are rendering twice, try removing strict mode temporarily
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </React.StrictMode>,
  );
}
